import React, { createContext, useContext } from 'react';
import { AuthenticatedUser } from '../types';

const UserContext = createContext<{ user: AuthenticatedUser } | undefined>(undefined);

export function useUserContext() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('User context can not be accessed outside UserProvider!');
    }
    return context;
}

export function UserProvider({ children, user }) {
    return <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>;
}
